import { ContainerTreeObject } from "@/frontend/types/navigationTypes";
import { ReportItemTreeObject } from "@/types/reportTypes";

export const tree = {
	find(data: ContainerTreeObject[], itemId: string): ContainerTreeObject | undefined {
    for (let i = 0; i < data.length; i+= 1) {
      const item = data[i];
      if (item.id === itemId) {
        return item;
      }
      if (tree.hasChildren(item)) {
        const result = tree.find(item.children, itemId);
        if (result) {
          return result;
        }
      }
    }
    return undefined;
	},
	hasChildren(item: ContainerTreeObject): boolean {
		return item.children.length > 0;
	},
  getPathToItem({
		current,
		targetId,
		parentIds = [],
	}: {
		current: ContainerTreeObject[];
		targetId: string;
		parentIds?: string[];
	}): string[] | undefined {
    for (let i = 0; i < current.length; i += 1) {
      const item = current[i];
      if (item.id === targetId) {
        return parentIds;
      }
      const nested = tree.getPathToItem({
        current: item.children,
        targetId,
        parentIds: [...parentIds, item.id],
      });
      if (nested) {
        return nested;
      }
    }
    return undefined;
	},
};

export const reportItemTree = {
	find(data: ReportItemTreeObject[], itemId: string): ReportItemTreeObject | undefined {
    for (let i = 0; i < data.length; i+= 1) {
      const item = data[i];
      if (item.id === itemId) {
        return item;
      }
      if (reportItemTree.hasChildren(item)) {
        const result = reportItemTree.find(item.reportItems, itemId);
        if (result) {
          return result;
        }
      }
    }
    return undefined;
	},
	hasChildren(item: ReportItemTreeObject): boolean {
		return item.reportItems.length > 0;
	},
  getPathToItem({
		current,
		targetId,
		parentIds = [],
	}: {
		current: ReportItemTreeObject[];
		targetId: string;
		parentIds?: string[];
	}): string[] | undefined {
    for (let i = 0; i < current.length; i += 1) {
      const item = current[i];
      if (item.id === targetId) {
        return parentIds;
      }
      const nested = reportItemTree.getPathToItem({
        current: item.reportItems,
        targetId,
        parentIds: [...parentIds, item.id],
      });
      if (nested) {
        return nested;
      }
    }
    return undefined;
	},
};
